module.exports = __webpack_public_path__ + "static/media/ic_leak_active.bb95fab8.png";